/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Formulario from 'components/public/Formulario/Formulario';
import { datosRegistroAlquiler } from 'utils/formData';
import { IAltaAlquiler, IFormulario, ISelectOptions } from 'utils/models/interfaces';
import { registroAlquiler } from 'services/servicioPost';
import { crearOpcionesTipos } from 'utils/utilities';
import { useError } from 'services/ErrorContext';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSalas } from 'utils/redux/features/salasSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';
import PageContainer from 'components/PageContainer/PageContainer';
import Spinner from 'components/public/Spinner/Spinner';
import { TodayOutlined } from '@mui/icons-material';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { Fecha } from 'utils/models/types';
import { anchoMaxLogueado } from 'utils/constants';
interface IFormAlquiler {
  titulo: string;
  variante: 'registro' | 'edicion';
  textoBoton: string;
  idAlq?: number;
}

const AltaAlquiler = ({ titulo, textoBoton }: IFormAlquiler) => {
  const [mensajeExito, setMensajeExito] = useState('');
  const { error, setError, clearError, loading, setLoading } = useError();
  const { salas, loadingSalas, errorSalas } = useSelector((state: RootState) => state.salas);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchSalas());
    clearError();
  }, [dispatch]);

  async function handleSubmit(data: IFormulario): Promise<void> {
    const fecha: Fecha = {
      FechaInicio: new Date(data.FechaInicio),
      FechaFin: new Date(data.FechaFin),
    };

    const request: IAltaAlquiler = {
      NombreInquilino: data.NombreInquilino,
      // @ts-expect-error -- form field typed by react-hook-form, not in interface
      SalaId: data.Sala || 0,
      Fecha: fecha,
      Monto: data.Monto,
      Telefono: data.Telefono,
    };

    try {
      await registroAlquiler(request, setError, setLoading);
      setMensajeExito('¡Alquiler registrado con éxito!');
    } catch (error) {
      console.error('Error de registro:', error);
    }
  }

  const opcionesSalas: ISelectOptions[] = crearOpcionesTipos(salas, 'Sala');

  const handleVolver = () => {
    setMensajeExito('');
  };

  const error401 = errorSalas?.includes('permisos');

  return (
    <PageContainer>
      {loadingSalas ? (
        <Spinner />
      ) : errorSalas ? (
        error401 ? (
          <NotAllowed />
        ) : (
          <NoResponse />
        )
      ) : (
        <Box maxWidth={anchoMaxLogueado} mx="auto">
          <Formulario
            campos={datosRegistroAlquiler}
            titulo={titulo}
            textoBoton={textoBoton}
            onSubmit={handleSubmit}
            datos={opcionesSalas}
            onVolver={handleVolver}
            mensajeExito={mensajeExito}
            mensajeError={error}
            loading={loading}
            iconoBoton={TodayOutlined}
          />
        </Box>
      )}
    </PageContainer>
  );
};

export default AltaAlquiler;
